import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5103cfd6")

_pushScopeId("data-v-5103cfd6")
const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { class: "w-auto mb-6 max-w-sm h-56 m-auto\n           rounded-3xl relative text-white shadow-2xl transition-transform transform lg:hover:scale-110" }
const _hoisted_3 = { class: "w-full px-8 absolute top-8" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-light" }
const _hoisted_6 = { class: "font-medium tracking-widest" }
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  alt: "",
  class: "w-14 h-14",
  src: "/img/test/Card.svg"
}, null, -1)
const _hoisted_8 = { class: "pt-1" }
const _hoisted_9 = { class: "font-light" }
const _hoisted_10 = { class: "font-medium tracking-more-wider" }
const _hoisted_11 = { class: "pt-6 pr-6" }
const _hoisted_12 = { class: "flex justify-between" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "font-light text-xs" }
const _hoisted_15 = { class: "font-medium tracking-wider text-sm" }
const _hoisted_16 = { class: "font-light text-xs text-xs" }
const _hoisted_17 = { class: "font-medium tracking-wider text-sm" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "font-light text-xs" }
const _hoisted_20 = { class: "font-bold tracking-more-wider text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_close = _resolveComponent("btn-close")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.CreditCards, (CreditCard) => {
      return (_openBlock(), _createBlock("div", {
        key: CreditCard.id,
        class: "mx-auto"
      }, [
        _createVNode(_component_btn_close, { "btn-position": "mr-7 md:mr-20 -mt-1" }),
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: CreditCard.url,
            alt: "",
            class: "relative object-cover w-full h-full rounded-3xl"
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", {
                id: CreditCard.id,
                class: ""
              }, [
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("payment.CreditCard.nameTitle")), 1),
                _createVNode("p", _hoisted_6, _toDisplayString(CreditCard.name), 1)
              ], 8, ["id"]),
              _hoisted_7
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("payment.CreditCard.cardNumberTitle")), 1),
              _createVNode("p", _hoisted_10, _toDisplayString(CreditCard.cardNumber), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("payment.CreditCard.validTitle")), 1),
                  _createVNode("p", _hoisted_15, _toDisplayString(CreditCard.valid), 1)
                ]),
                _createVNode("div", {
                  id: CreditCard.id,
                  class: ""
                }, [
                  _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("payment.CreditCard.expireTitle")), 1),
                  _createVNode("p", _hoisted_17, _toDisplayString(CreditCard.expire), 1)
                ], 8, ["id"]),
                _createVNode("div", _hoisted_18, [
                  _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("payment.CreditCard.csvTitle")), 1),
                  _createVNode("p", _hoisted_20, _toDisplayString(CreditCard.csv), 1)
                ])
              ])
            ])
          ])
        ])
      ]))
    }), 128))
  ]))
})